'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

var _pacomo = require('utils/pacomo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StartHeader = function StartHeader() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'h2',
            null,
            _react2.default.createElement('img', { src: require('theme/img/g_logo.svg'), alt: 'Good To Go Trademark', title: 'Good To Go' })
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'startHeader.selectPassenger',
                defaultMessage: 'Select the traveller for whom you\'d like to enter requirement information.' })
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'startHeader.remindPassenger',
                defaultMessage: 'Send an email reminder to a fellow traveller if you would like them to complete their Good to Go documents.' })
        )
    );
};

exports.default = (0, _pacomo.pacomoTransformer)(StartHeader);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/PassengerList/StartHeader.js
// module id = 1310
// module chunks = 0